document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('[data-env-autoplay]').forEach(function(video){
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){var promise=video.play();if(promise&&promise.catch){promise.catch(function(){});}}
        else{video.pause();}
      });
    },{threshold:.2});
    io.observe(video);
  });
});

